/**
 * RobiQuickAnswerDisclaimerModal — one-time notice shown before the first
 * "Ask anything!" chat, explaining how Robi differs from the AI Buddy.
 */
import { useState } from 'react';
import { useTranslation } from '@wlb/shared/i18n/useTranslation';
import { Button } from '../../components/ui/Button';
import { Modal } from '../../components/ui/Modal';
import disclaimerImage from '../../assets/images/ai-disclaimer.png';
import './robi.css';

interface RobiQuickAnswerDisclaimerModalProps {
  onClose: () => void;
  onContinue: (dontShowAgain: boolean) => void;
}

export function RobiQuickAnswerDisclaimerModal({
  onClose,
  onContinue,
}: RobiQuickAnswerDisclaimerModalProps) {
  const { t } = useTranslation();
  const [dontShowAgain, setDontShowAgain] = useState(false);

  return (
    <Modal
      className="robi-disclaimer"
      labelledBy="robi-disclaimer-title"
      title={t('robi.disclaimer.title')}
      onClose={onClose}
    >
      <div className="robi-disclaimer__body">
        <img className="robi-disclaimer__image" src={disclaimerImage} alt="" aria-hidden />
        <p className="robi-disclaimer__description">{t('robi.disclaimer.description')}</p>
        <label className="robi-disclaimer__opt-out">
          <input
            type="checkbox"
            checked={dontShowAgain}
            onChange={event => setDontShowAgain(event.target.checked)}
          />
          <span>{t('robi.disclaimer.dontShowAgain')}</span>
        </label>
      </div>
      <div className="robi-disclaimer__actions">
        <Button variant="outline" size="md" onClick={onClose}>
          {t('common.buttons.close')}
        </Button>
        <Button size="md" onClick={() => onContinue(dontShowAgain)}>
          {t('robi.disclaimer.continue')}
        </Button>
      </div>
    </Modal>
  );
}
